import styled from 'styled-components';

import { BaseStyle, Select, ReactTableStyles } from '@nhl/nhl-breakaway-ui';

export const Header = styled.div`
    ${BaseStyle.Mixins.gaps.large}
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const SelectContainer = styled.div`
    ${BaseStyle.Mixins.screenSizes.medium} {
        grid-template-columns: 200px 200px;
        grid-column-gap: 24px;
        padding: 32px 0;
    }

    display: grid;
    grid-template-columns: 1fr;
    row-gap: 16px;
    padding: 24px 0;
`;

export const StyledSelect = styled(Select)`
    ${BaseStyle.Mixins.screenSizes.medium} {
        width: 198px;
    }

    width: 100%;
`;

export const PositionTitle = styled.h4`
    padding-bottom: 16px;
`;

export const ClubStatsTableContainer = styled.div`
    margin-bottom: 30px;

    ${ReactTableStyles.CommonTableStyling};

    .rt-table-container {
        ${ReactTableStyles.TableScrollShadows};
    }
`;
